export class Departement {
    constructor(
        public code?: string,
        public libelle?: string,
    ) { }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/grhum/departement.model.ts